// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-stats-header-trophy {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  padding: 16px 5px;
  align-items: center;
}
@media (max-width: 925px) {
  .user-stats-header-trophy {
    padding: 5px;
  }
}

.series-container {
  border: 1px solid #000;
  border-radius: 5px;
  font-size: 8px;
  margin: 8px auto;
}

.user-stats-trophy {
  width: 48px;
}
@media (max-width: 925px) {
  .user-stats-trophy {
    width: 20px;
    padding-right: 5px;
  }
}

.bracket-box-header {
  width: 100%;
  background: #F2F2F2;
  height: 257px;
  border-top: 8px solid #FFC60A;
  border-bottom: 8px solid #FFC60A;
}
@media (max-width: 925px) {
  .bracket-box-header {
    height: 87px;
    border-top: 4px solid #FFC60A;
    border-bottom: 4px solid #FFC60A;
  }
}

.user-stats-username {
  font-weight: 700 !important;
  font-size: 40px;
}
@media (max-width: 925px) {
  .user-stats-username {
    color: #002129;
    font-family: Inter;
    font-size: 16px !important;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
}

.user-stats-headings {
  color: #4A4A4A;
  text-align: center;
  font-family: Inter;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  text-decoration-line: underline;
  font-size: 18px !important;
}
@media (max-width: 925px) {
  .user-stats-headings {
    font-size: 10px !important;
    font-weight: 800 !important;
  }
}

.user-stats-values {
  color: #4A4A4A;
  text-align: center;
  font-family: Inter;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  font-size: 24px !important;
}
@media (max-width: 925px) {
  .user-stats-values {
    font-size: 12px !important;
    font-weight: 800;
  }
}

.pillbox-navigation-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 327px;
  background-color: #fff;
  overflow: hidden;
  padding: 11.5px 62px;
  box-sizing: border-box;
  gap: 8px;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  font-size: 12px;
  color: #002129;
  font-family: "Inter", sans-serif;
}
@media (min-width: 768px) {
  .pillbox-navigation-bar {
    gap: 16px;
  }
}

.user-stats-button {
  width: 94px;
  height: 33px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 7px;
  white-space: nowrap;
}
.user-stats-button.active {
  border: 1px solid #002129;
  background-color: #e8e8e8;
  color: #002129;
}
.user-stats-button.inactive {
  border: 1px solid #9d9d9d;
  color: #9d9d9d;
  background-color: #fff;
}
@media (min-width: 768px) {
  .user-stats-button {
    width: 107px;
    height: 36px;
  }
}

.user-stats-button-text {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 9px;
  cursor: pointer;
}
@media (min-width: 768px) {
  .user-stats-button-text {
    font-size: 14px !important;
    height: 12px;
  }
}

.line-text {
  position: relative;
  letter-spacing: 0.46px;
  line-height: 7px;
  font-size: 10px !important;
  font-weight: 500;
  display: inline-block;
  min-width: 27px;
}
@media (min-width: 768px) {
  .line-text {
    font-size: 14px !important;
    height: 12px;
  }
}

.line-container {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 4px 0 3px;
}

.team-logo-img {
  height: 32px;
  width: 32px;
  position: relative;
  object-fit: contain;
}

.logo-border,
.logo-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}

.logo-border {
  border: 1px solid #000;
  overflow: hidden;
}

.logo-container {
  padding: 0 2px 0 1px;
}

.team-text {
  height: 7px;
  font-size: 10px !important;
  position: relative;
  letter-spacing: 0.46px;
  line-height: 26px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
}
@media (min-width: 768px) {
  .team-text {
    font-size: 14px !important;
    height: 12px;
  }
}

.pick-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 2px;
  box-sizing: border-box;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  font-size: 10px;
  color: #002129;
  font-family: Inter;
}`, "",{"version":3,"sources":["webpack://./src/components/GameModals/PickEmModals/PickEmUserStats/PickEmUserStatsModal.scss"],"names":[],"mappings":"AAKA;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;AAJF;AAKE;EAPF;IAQI,YAAA;EAFF;AACF;;AAKA;EACE,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAFF;;AAKA;EACE,WAAA;AAFF;AAGE;EAFF;IAGI,WAAA;IACA,kBAAA;EAAF;AACF;;AAGA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,gCAAA;AAAF;AACE;EANF;IAOI,YAAA;IACA,6BAAA;IACA,gCAAA;EAEF;AACF;;AACA;EACE,2BAAA;EACA,eAAA;AAEF;AADE;EAHF;IAII,cAAA;IACA,kBAAA;IACA,0BAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;EAIF;AACF;;AAAA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;EACA,0BAAA;AAGF;AADE;EAVF;IAWI,0BAAA;IACA,2BAAA;EAIF;AACF;;AAAA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;AAGF;AADE;EATF;IAUI,0BAAA;IACA,gBAAA;EAIF;AACF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gCAAA;AAGF;AADE;EAlBF;IAmBI,SAAA;EAIF;AACF;;AADA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;AAIF;AAFE;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAIJ;AADE;EACE,yBAAA;EACA,cAAA;EACA,sBAAA;AAGJ;AACE;EAvBF;IAwBI,YAAA;IACA,YAAA;EAEF;AACF;;AACA;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;AAEF;AAAE;EAVF;IAWI,0BAAA;IACA,YAAA;EAGF;AACF;;AAGE;EACE,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AAAJ;AAEI;EATF;IAUI,0BAAA;IACA,YAAA;EACJ;AACF;;AACE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AAEJ;;AAAE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAGJ;;AADE;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AAIJ;;AAFE;EACE,sBAAA;EACA,gBAAA;AAKJ;;AAHE;EACE,oBAAA;AAMJ;;AAJE;EACE,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAOJ;AALI;EAZF;IAaI,0BAAA;IACA,YAAA;EAQJ;AACF;;AANE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AASJ","sourcesContent":["$breakpoint-xs: 480px;\n$breakpoint-sm: 768px;\n$breakpoint-md: 925px;\n$breakpoint-lg: 1366px;\n\n.user-stats-header-trophy{\n  width:100%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  padding:16px 5px;\n  align-items: center;\n  @media (max-width: $breakpoint-md) {\n    padding: 5px;\n  }\n}\n\n.series-container{\n  border:1px solid #000;\n  border-radius: 5px;\n  font-size: 8px;\n  margin: 8px auto;\n}\n\n.user-stats-trophy{\n  width:48px;\n  @media (max-width: $breakpoint-md) {\n    width: 20px;\n    padding-right: 5px;\n  }\n}\n\n.bracket-box-header{\n  width: 100%;\n  background: #F2F2F2;\n  height:257px;\n  border-top: 8px solid #FFC60A;\n  border-bottom: 8px solid #FFC60A;\n  @media (max-width: $breakpoint-md) {\n    height:87px;\n    border-top: 4px solid #FFC60A;\n    border-bottom: 4px solid #FFC60A;\n  }\n}\n\n.user-stats-username {\n  font-weight: 700 !important;\n  font-size: 40px;\n  @media (max-width: $breakpoint-md) {\n    color: #002129;\n    font-family: Inter;\n    font-size: 16px !important;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    // padding: ;\n  }\n}\n\n.user-stats-headings {\n  color: #4A4A4A;\n  text-align: center;\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 800;\n  line-height: normal;\n  text-decoration-line: underline;\n  font-size: 18px !important;\n\n  @media (max-width: $breakpoint-md) {  // Uses variable for breakpoint\n    font-size: 10px !important;  // Smaller font size on smaller screens\n    font-weight: 800 !important;\n\n  }\n}\n\n.user-stats-values {\n  color: #4A4A4A;\n  text-align: center;\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 800;\n  line-height: normal;\n  font-size: 24px !important;\n\n  @media (max-width: $breakpoint-md) {  // Uses variable for breakpoint\n    font-size: 12px !important;  // Smaller font size on smaller screens\n    font-weight: 800;\n\n  }\n}\n\n.pillbox-navigation-bar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 327px;\n  background-color: #fff;\n  overflow: hidden;\n  padding: 11.5px 62px;\n  box-sizing: border-box;\n  gap: 8px;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  font-size: 12px;\n  color: #002129;\n  font-family: 'Inter', sans-serif;\n\n  @media (min-width: 768px) {\n    gap: 16px;\n  }\n}\n\n.user-stats-button {\n  width: 94px;  // Default width for mobile\n  height: 33px; // Default height for mobile\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 7px;\n  white-space: nowrap;\n\n  &.active {\n    border: 1px solid #002129;\n    background-color: #e8e8e8;\n    color: #002129;\n  }\n\n  &.inactive {\n    border: 1px solid #9d9d9d;\n    color: #9d9d9d;\n    background-color: #fff;\n  }\n\n  // Media query for non-mobile screens\n  @media (min-width: 768px) {\n    width: 107px; // Width for non-mobile\n    height: 36px; // Height for non-mobile\n  }\n}\n\n.user-stats-button-text {\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  color: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 9px;\n  cursor: pointer;\n\n  @media (min-width: 768px) {\n    font-size: 14px !important;\n    height: 12px;\n  }\n}\n\n  \n\n\n  .line-text {\n    position: relative;\n    letter-spacing: 0.46px;\n    line-height: 7px;\n    font-size: 10px !important;\n    font-weight: 500;\n    display: inline-block;\n    min-width: 27px;\n\n    @media (min-width: 768px) {\n      font-size: 14px !important;\n      height: 12px;\n    }\n  }\n  .line-container {\n    align-self: stretch;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    padding: 0 4px 0 3px;\n  }\n  .team-logo-img {\n    height: 32px;\n    width: 32px;\n    position: relative;\n    object-fit: contain;\n  }\n  .logo-border,\n  .logo-container {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n  .logo-border {\n    border: 1px solid #000;\n    overflow: hidden;\n  }\n  .logo-container {\n    padding: 0 2px 0 1px;\n  }\n  .team-text {\n    height: 7px;\n    font-size: 10px !important;\n    position: relative;\n    letter-spacing: 0.46px;\n    line-height: 26px;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 34px;\n\n    @media (min-width: 768px) {\n      font-size: 14px !important;\n      height: 12px;\n    }\n  }\n  .pick-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    padding: 0 2px;\n    box-sizing: border-box;\n    line-height: normal;\n    letter-spacing: normal;\n    text-align: center;\n    font-size: 10px;\n    color: #002129;\n    font-family: Inter;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
